import React, { useEffect, useRef } from 'react';

import { Box } from '@mui/material';

export default function FilterSidePanel({
  narrow,
  onOpen,
  children,
}: {
  narrow: boolean;
  onOpen: (open: boolean) => void;
  children: React.ReactNode;
}) {
  const panel = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!narrow) {
      return undefined;
    }
    const outside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!panel.current?.contains(target) && !target.closest('.MuiPopover-root')) {
        onOpen(false);
      }
    };
    const escape = (event: KeyboardEvent) => event.key === 'Escape' && onOpen(false);
    window.document.addEventListener('mousedown', outside);
    window.document.addEventListener('keydown', escape);
    return () => {
      window.document.removeEventListener('mousedown', outside);
      window.document.removeEventListener('keydown', escape);
    };
  }, [narrow, onOpen]);
  return (
    <Box
      aria-label="Filters"
      className={narrow ? 'side open sheet' : 'rail-panel'}
      data-lens-filters
      ref={panel}
      role="group"
    >
      <Box className="side-body">{children}</Box>
    </Box>
  );
}
